import "./Footer.scss";

import { memo } from "react";
import { FCC } from "types";

import { Claim } from "@/components/Layout/BaseLayouts/Footer/Claim/Claim.tsx";
import { SocialButtonMenu } from "@/components/Layout/BaseLayouts/Footer/SocialButtonMenu.tsx";

import { CollapsibleLanguageMenu } from "./CollapsibleLanguageMenu";
import { CollapsibleLinkMenu } from "./CollapsibleLinkMenu";
import { LinkMenu } from "./LinkMenu";
import { SupportLinkItem } from "./SupportLinkItem";

export const Footer: FCC = memo(() => {
  return (
    <footer id="base-layout-footer-wrapper" data-testid="footer">
      <div className="footer">
        <div className="footer-inner grid-container p-6 desktop:p-8">
          <div className="footer-top grid grid-cols-4 pb-6 tablet:grid-cols-12 tablet:pb-0 desktop:grid-cols-16">
            <div className="col-span-4 desktop:col-span-5">
              <div className="pb-4 tablet:pb-0">
                <CollapsibleLanguageMenu />
              </div>
            </div>
            <div className="col-span-4 desktop:col-span-5">
              <div className="pb-4 tablet:pb-0">
                <CollapsibleLinkMenu />
              </div>
            </div>
            <div className="col-span-4 desktop:col-span-6">
              <SupportLinkItem />
            </div>
          </div>
          <div className="footer-bottom grid grid-cols-4 tablet:grid-cols-12 desktop:grid-cols-16">
            <div className="col-span-4 flex items-center pb-6 tablet:col-span-3 tablet:pb-0 desktop:col-span-3">
              <SocialButtonMenu />
            </div>
            <div className="col-span-4 flex items-center tablet:col-span-6 desktop:col-span-10">
              <LinkMenu />
            </div>
            <div className="col-span-4 flex items-center tablet:col-span-3 tablet:justify-end desktop:col-span-3">
              <Claim />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});
